import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IContact, IContactInitialState } from "./contactsModal";
import {
  ActiveInactiveContact,
  ContactImageUpload,
  createContact,
  deleteContact,
  getAllActiveContacts,
  getAllContacts,
  getContactByID,
  updateContact,
} from "./services/contacts.services";

const initialState: IContactInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  ContactID: null,
  ContactList: [],
  ContactDetail: {
    Name: "",
    Email: "",
    MobileNo: "",
    Remarks: "",
    InquiryDate: "",
    IsActive: 1,
  },
};

const contactsSlice = createSlice({
  name: "contacts",
  initialState,
  reducers: {
    clearContactDetails: (state) => {
      state.ContactDetail = initialState.ContactDetail;
    },
    setContactID: (state, action) => {
      state.ContactID = action.payload;
    },
    clearContactID: (state) => {
      state.ContactID = initialState.ContactID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllContacts.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllContacts.fulfilled,
      (state, action: PayloadAction<IContact[]>) => {
        state.loading = false;
        state.ContactList = action.payload || [];
      }
    );
    builder.addCase(getAllContacts.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ContactList = [];
    });
    builder.addCase(createContact.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createContact.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createContact.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateContact.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(updateContact.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateContact.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteContact.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteContact.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteContact.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getContactByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getContactByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.ContactDetail = action.payload;
    });
    builder.addCase(getContactByID.rejected, (state, action) => {
      state.formLoading = false;
      state.ContactDetail = initialState.ContactDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveContacts.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveContacts.fulfilled,
      (state, action: PayloadAction<IContact[]>) => {
        state.loading = false;
        state.ContactList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveContacts.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ContactList = [];
    });
    builder.addCase(ActiveInactiveContact.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveContact.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveContact.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(ContactImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ContactImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ContactImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearContactDetails, clearContactID, setContactID } =
  contactsSlice.actions;
export default contactsSlice.reducer;
